import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import WelcomeModal from "@/components/WelcomeModal";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Samples from "@/pages/Samples";
import Customers from "@/pages/Customers";
import FollowUps from "@/pages/FollowUps";
import Tasks from "@/pages/Tasks";
import Notes from "@/pages/Notes";
import OmavalvontaHome from "@/pages/OmavalvontaHome";
import HygieneChecks from "@/pages/HygieneChecks";
import RawMaterialChecks from "@/pages/RawMaterialChecks";
import Incidents from "@/pages/Incidents";
import LabTests from "@/pages/LabTests";
import ProductionBatches from "@/pages/ProductionBatches";
import Traceability from "@/pages/Traceability";
import Products from "@/pages/Products";
import Orders from "@/pages/Orders";
import Invoices from "@/pages/Invoices";
import Inventory from "@/pages/Inventory";
import Waste from "@/pages/Waste";
import Login from "@/pages/Login";
import AuthorizedUsers from "@/pages/AuthorizedUsers";
import { AuthProvider } from "@/auth/AuthProvider";
import AuthCallback from "@/auth/AuthCallback";
import ProtectedRoute from "@/auth/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback (#session_id=...) during render to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <>
              <WelcomeModal />
              <Layout />
            </>
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/products" element={<Products />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/waste" element={<Waste />} />
        <Route path="/production" element={<ProductionBatches />} />
        <Route path="/samples" element={<Samples />} />
        <Route path="/traceability" element={<Traceability />} />
        <Route path="/followups" element={<FollowUps />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/omavalvonta" element={<OmavalvontaHome />} />
        <Route path="/omavalvonta/hygiene" element={<HygieneChecks />} />
        <Route path="/omavalvonta/raw-material" element={<RawMaterialChecks />} />
        <Route path="/omavalvonta/incidents" element={<Incidents />} />
        <Route path="/omavalvonta/lab-tests" element={<LabTests />} />
        <Route path="/hygiene" element={<HygieneChecks />} />
        <Route path="/raw-materials" element={<RawMaterialChecks />} />
        <Route path="/incidents" element={<Incidents />} />
        <Route path="/lab-tests" element={<LabTests />} />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute adminOnly>
              <AuthorizedUsers />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
